/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankCode {
  _081 = '081',
  _003 = '003',
  _004 = '004',
  _020 = '020',
  _088 = '088',
  _011 = '011',
  _027 = '027',
  _023 = '023',
  _089 = '089',
  _090 = '090',
  _045 = '045',
  _071 = '071',
  _002 = '002',
  _007 = '007',
  _031 = '031',
  _032 = '032',
  _034 = '034',
  _035 = '035',
  _037 = '037',
  _039 = '039',
  _092 = '092',
}
